import { IconPlaceholderImages24 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './NoImage.css';

interface INoImageProps {
  borderRadius?: number;
}

export function NoImage({ borderRadius = 4 }: INoImageProps) {
  return (
    <div className={styles['image']} style={{ borderRadius: `${borderRadius}px` }}>
      <IconPlaceholderImages24 width={40} height={40} color="icon-secondary-default" />
    </div>
  );
}
